<template>    
    <div class="card">
        <div class="card-header p-0 border-bottom-0">
            <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                <li class="nav-item">
                    <a 
                        :class="tab == 'precios' ? 'nav-link active' : 'nav-link'" 
                        href="#"
                        @click.prevent="tab = 'precios'"
                    >
                        Configurar precios
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        :class="tab == 'descuentos' ? 'nav-link active' : 'nav-link'" 
                        href="#"
                        @click.prevent="tab = 'descuentos'"
                    >
                        Configurar cupones de descuento
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane fade active show">
                    <transition name="fade" mode="out-in">
                        <div key="1" class="overlay-wrapper" v-if="tab == 'precios'">
                            <Precios :evento_id="evento_id" :sesion_id="sesion_id"></Precios>
                        </div>
                        <div key="2" class="overlay-wrapper" v-if="tab == 'descuentos'">
                            <Vouchers :event_id="evento_id" :session_id="sesion_id"></Vouchers>
                        </div>
                    </transition>
                </div>                        
            </div>
        </div>
    </div>                
</template>

<script>
import Precios from './Precios';
import Vouchers from './Vouchers';

export default {
    props: ['evento_id', 'sesion_id'],
    data() {
        return {
            tab: 'precios'
        }
    },
    components: {
        Precios, Vouchers
    }
}
</script>
